{
  "0059798b7f7023e4": "(optional)",
  "04588a6aae45676a": "Tell us what you'd like changed",
  "0737222a82dd51a8": "CSV or Excel (.xlsx)",
  "07b5d93b0cff13c5": "Request sent. We'll review and follow up.",
  "0884d6ee37e87a32": "Posted more than {{count}} days before shift start",
  "09291fd3a298ea2f": "Remove workers",
  "0c370ec3af873d9e": "Failed to load qualifications. Please close and try again.",
  "11a6767d5674c7e4": "Done",
  "142a2b7bfce29b37": "Exit select mode",
  "17e6c06f18ed21bd": "Link to Roster",
  "18beff7fbca20740": "Baseline hrs",
  "18c9a2cfec15c4fd": "Row {{number}}",
  "19766ed6ccb2f4a3": "Cancel",
  "1e7986999c544433": "Your Roster has been marked as up to date",
  "1fc9a387654d410f": "Select all",
  "24017c138bb440e0": "Cannot modify name, phone or email because this information is linked to this worker's existing Clipboard profile.",
  "2707b724bbbb0e20": "Something look wrong? Message #proj-clipboard-roster with issues.",
  "290056e834ccabee": "Edit worker",
  "2a78025de6aae5e7": "Select",
  "2d0dfab0d1858ed7": "Baseline weekly hours must be a number between 0 and {{max}}",
  "306f1bb20677a622": "Phone number",
  "309955e00850b8af": "Common",
  "3321b9f6e65c542a": "Date added",
  "35765e54d942291c": "Upload failed. Please try again.",
  "374e1b8eda8b2676": "Posted less than {{count}} days before shift start",
  "394aac2bde696049": "We found a matching worker for {{phoneNumber}}",
  "40d92c1dcf20e5a4": "Opens to your Roster and Clipboard immediately.",
  "4479c67aad5130f6": "Upload a CSV or Excel file with columns for Full Name, Phone, Licenses/qualifications, and an optional Email. You can add up to {{max}} workers at a time.",
  "45d157e9b9634c7a": "{{created}} added · {{skipped}} skipped · {{invalid}} couldn't be added",
  "464c4ffd019e1e96": "Edit",
  "47f25f763e0dbcfb": "Are you sure you want to exit?",
  "4df6007d82926e3b": "We couldn't read that file. Upload a CSV or Excel (.xlsx) file.",
  "509118b69ec228a4": "Couldn't send your request. Please try again.",
  "514ff9ef71f7b053": "Failed to update your Roster. Please try again.",
  "5316450fd4da39c7": "You'll lose your changes for this Roster professional.",
  "566ca164eea12dbe": "They will not be able to book shifts through Roster as in-house staff members. You can re-add them at any time.",
  "61807ec7fd686900": "Search by name, phone, or email",
  "63dceb8800b2dd4a": "Phone",
  "67f46a1d5a5dcd97": "Download CSV template",
  "68939dc24dce5ef6": "Posted {{urgent}}-{{long}} days before shift start",
  "6b02e0d363a4af1c": "Added",
  "6eea8608c452711b": "Email (optional)",
  "74fa562f32ea8c7d": "Email can't be cleared once set. Enter a new email or restore the previous one.",
  "76dfed04f989a28b": "This workplace has no qualifications configured. Contact support to enable PRN roster.",
  "78d22b05b5081f52": "Remove selected",
  "78d9d31ef4d4f2ae": "from your Roster?",
  "7b4339cf860e01a6": "Qualifications",
  "7b94628acb624e04": "Drag and drop, or click to choose a file",
  "7eab65b15b80284e": "This worker is already in your Roster. Edit the existing record to update their information.",
  "7f58d87c3a2bc3bc": "They will not be able to book shifts through Roster as an in-house staff member. You can re-add them at any time.",
  "80e69fabf23106f4": "{{count}} workers ready to upload.",
  "83e80546585ea5ad": "Skipped (already on Roster)",
  "861b38f2b1ed5692": "Add worker to Roster",
  "89db19f651b18285": "(required)",
  "91b1646d0b92a19a": "We couldn't find any workers. Make sure your file has Full Name, Phone, and Licenses/qualifications columns.",
  "94605bf24653cf87": "Remove {{count}} {{noun}} from your Roster?",
  "95f4e8338213e418": "Add to Roster",
  "967549497036d513": "Deselect all",
  "969ccbd3cf6300ec": "Email",
  "96cfc37342fa7ddb": "Briefly describe what you'd like adjusted and why.",
  "a1dc12a7788084dd": "is already on Clipboard with this phone number. Add them to your Roster?",
  "a5145b2fe67f98b4": "Baseline weekly hours",
  "aa8be0de6081a385": "We couldn't find any workers. Make sure your file has Full Name, Phone, and Qualifications columns.",
  "ad9b0ab77a839caa": "Bulk upload workers",
  "b13c9ea94acf9b0f": "Couldn't add",
  "b9c6d434be0083c0": "Opens to Clipboard {{count}} days before shift start.",
  "bb9c8d03519c80e3": "Mark Roster as up to date",
  "bc9a0f00e968cada": "Opens to Clipboard {{count}} days after posting.",
  "bf180fbea0d8415e": "Roster has not been updated in over 10 days and may be out of date",
  "c08431714df238ca": "Remove worker",
  "c3812fc4acb861d5": "Remove",
  "c7f761b38b197daa": "{{count}} selected",
  "c8df66c5fe3f97d0": "Close dialog",
  "d3d651871073a476": "No workers match your search.",
  "d44699007014bc97": "Roster window",
  "d6d2775b0d5824d1": "Upload a CSV or Excel file with these columns. You can add up to {{max}} workers at a time.",
  "dab1cccf0c8003b3": "Request a change",
  "dcd1d5223f73b3a9": "Name",
  "dd0ae7a5cbcf2339": "Save changes",
  "e032a95ab3e797fb": "Bulk upload",
  "e534713dbafc3f36": "Change request note",
  "e65d6db2e90987e2": "Choose a file to upload",
  "ea540f069c20ad18": "That file has {{count}} workers. Upload at most {{max}} at a time.",
  "ec3d5ef3ac1e44e7": "How soon shifts open to Clipboard professionals, after your Roster gets the first look.",
  "f13a64ba2fea87ef": "Full name",
  "f13ab872339af3f4": "Upload {{count}} workers",
  "f6f4688ff23d50c6": "Send",
  "f97e9da0e3b879f0": "Other"
}
